const graphUtils = {

  getTransitionDistance(startX, startY, endX, endY) {
    // return Math.sqrt( (b[0] - a[0]) * (b[0] - a[0]) + (b[1] - a[1]) * (b[1] - a[1]) );
    return Math.sqrt(
      (endX - startX) * (endX - startX)
      +
      (endY - startY) * (endY - startY)
    );
  }

  , getTransitionAngle(startX, startY, endX, endY) {
    // returns from -180 to 180 based on angle of line drawn
    //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/atan2
    // more note: this is confusing because html position counts Y's downward instead of upward
    // this would normally be (endY - startY)
    const angleRadians = Math.atan2((startY - endY),(endX - startX));
    // console.log("RADIANS", angleRadians)
    // const angleDegrees = angleRadians * 180 / Math.PI;
    // console.log("ANGLE", angleDegrees);
    return angleRadians * 180 / Math.PI;

  }

  , getTransitionPath(startX, startY, endX, endY) {
    // no idea how to do this from scratch. adapted from following links:
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths
    // const d = this.getTransitionDistance(startX, startY, endX, endY);
    // return `M${startX},${startY} C${startX + d * 0.25},${startY} ${endX - d * 0.75},${endY}  ${endX},${endY}`
    //^this is cool, but straight lines might be preferable from a useability perspective

    // //simpler curve
    // const ctrlPoint = `${endX + 10},${endY + 10}`
    // return `M${startX},${startY} Q ${ctrlPoint} ${endX},${endY}`

    // const a = this.getTransitionAngle(startX, startY, endX, endY);

    // simple straight lines
    return `M${startX},${startY} L ${endX}, ${endY}`
  }

  , getTransitionMarker(startX, startY, endX, endY) {
    //svg markers: https://www.w3.org/TR/SVG/painting.html#Markers
    // const d = this.getTransitionDistance(startX, startY, endX, endY);
    const dx = endX - startX;
    const dy = endY - startY;
    // console.log("dx, dy", dx, dy)

    /* NOTE: Here is the original return statement:

    return `M${startX},${startY} L ${endX - dx * 0.48}, ${endY - dy * 0.48}`

     * That 0.48 is the percentage along the line that the marker will be placed.
     * We need to replace that with a scaling percentage to keep markers at a desired 
     * distance from the end node regardless of line length.
    
     * nodeRadius is the distance from the center of the end node that
     * we want to place the marker. It keeps arrows from getting too close and hiding
     * under the end node. */
    const nodeRadius = 250;

    /* We'll use the longer of the x and y distances to calculate our percentage. */
    const longestLine = (Math.abs(dx) > Math.abs(dy) ? dx : dy)

    /* markerDistance is the scaling percentage needed to maintain the desired
     * nodeRadius as the lines get longer or shorter.*/
    let markerDistance = Math.abs(nodeRadius / (2 * longestLine));

    /* cap markerDistance below 50% so that two arrows on the same short line will
     * maintain distance between them. */
    if(markerDistance > 0.48) {
      markerDistance = 0.48;
    }

    /* The new return statement is the same as the original except we've replaced 0.48 with our
     * scaling percentage. */  
    return `M${startX},${startY} L ${endX - (dx * markerDistance)}, ${endY - (dy * markerDistance)}`;
  }

  , getNodeClassNames(node) {
    // determine css classes to use on a node based on it's own properties
    // NOTE: all fairly arbitrary, color + shape
    if(node.start) {
      return ['start']
    } else if(node.exit) {
      return ['exit']
    // } else if(node.toc) {
      // return ['toc']
    // } else if(node.checkpoint) {
      // return ['checkpoint']
    } else if(node.question) {
      return ['question']
    } else if(node.answer && node.correct == 'correct') {
      return ['correct']
    } else if(node.answer && node.correct == 'incorrect') {
      return ['incorrect']
    // } else if(node.metric.length > 0) {
    //   return ['default', 'circle']
    } else {
      return ['default']
    }
  }

}

export default graphUtils;



// WEBPACK FOOTER //
// global/utils/graphUtils.js